// extracted by mini-css-extract-plugin
export default {"icons":"CartIcon_icons__58+jD","icons__cart":"CartIcon_icons__cart__umn9G"};